import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const PillsCarousel = {
  init() {
    const section = document.querySelector('.pills-section');
    if (!section) return;

    const container = section.querySelector('.swiper');
    const nextBtn = section.querySelector('.pills-button-next');
    const prevBtn = section.querySelector('.pills-button-prev');

    const swiper = new Swiper(container, {
    modules: [Navigation],
    loop: true,
    slidesPerView: 5,
    spaceBetween: 60,
    speed: 1500,
    navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
    },
    breakpoints: {
        768:  { slidesPerView: 6 },
        1024: { slidesPerView: 8 },
        1280: { slidesPerView: 10 },
    },
    on: {
        slideChange: function () {
            setTimeout(() => {
                let activeElem = document.querySelector('.pill-slide.swiper-slide-next').nextElementSibling;
                let title = activeElem.dataset.title;
 
                if (title) {
                    document.querySelector('.pills-circle__title').textContent = title || '';
                }
            }, 10);
        }
    }
    });

    function updateSlidesCount(swiper) {
        swiper.el.style.setProperty(
            '--slides-count',
            swiper.params.slidesPerView
        );
    }

    updateSlidesCount(swiper);

    swiper.on('breakpoint', function () {
        updateSlidesCount(swiper);
    });

    const speedSetting = parseInt(container.dataset.scrollSpeed, 10);

    let autoSlideInterval = null;

    const getDelayFromSetting = (value) => {
    if (value === 0) return null;

    const maxDelay = 5000;
    const minDelay = 100;

    const step = (maxDelay - minDelay) / 4;
    return maxDelay - (value - 1) * step;
    };

    const startAutoSlide = () => {
        swiper.params.speed = 1500;
    const delay = getDelayFromSetting(speedSetting);
    if (!delay) return;

    autoSlideInterval = setInterval(() => {
        swiper.slideNext();
    }, delay);
    };

    const stopAutoSlide = () => {
        swiper.params.speed = 500;
    if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
        autoSlideInterval = null;
    }
    };

    if (speedSetting > 0) {
    startAutoSlide();
    }

    nextBtn.addEventListener('mouseenter', stopAutoSlide);
    prevBtn.addEventListener('mouseenter', stopAutoSlide);

    nextBtn.addEventListener('mouseleave', startAutoSlide);
    prevBtn.addEventListener('mouseleave', startAutoSlide);

    nextBtn.addEventListener('click', () => {
      stopAutoSlide();
      swiper.slideNext();
    });

    prevBtn.addEventListener('click', () => {
      stopAutoSlide();
      swiper.slidePrev();
    });
  }
};

export default PillsCarousel;
